export default __webpack_public_path__ + "static/media/hd8.a8b2d5ce.webp";